import React, { Component, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { getFirstLastDayWeek, AddDays, RemoveDays, formatDate } from '@utils';
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';
import { GetLanguage } from '@utils/language';
import * as storage from '@utils/storage'
import { Calendar } from "@progress/kendo-react-dateinputs";
import Button from '@material-ui/core/Button';
import { IntlProvider, LocalizationProvider } from "@progress/kendo-react-intl";
import moment from "moment";
import "moment/locale/fr";
import styles from '@styles/timesheet.module.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate } from "@fortawesome/pro-duotone-svg-icons";

moment.locale("fr");

const useStyles = makeStyles((theme) => ({
    rootSelectWeek: {
        paddingLeft: '27px',
        backgroundColor: '#5c7fb9',
        color: '#ffffff',
        border: '2px solid #ffffff',
        borderRadius: '10px'
    },
    refreshButton: {
        position: 'relative',
        right: '-22px'
    }
}));

function WeekSelect(props) {
    const classes = useStyles();

    const [startWeekDay, setStartWeekDay] = React.useState(storage.getStartDayTimesheet());
    const [startDate, setStartDate] = React.useState(null);
    const [endDate, setEndDate] = React.useState(null);
    const [selectedDate, setSelectedDate] = React.useState(null);
    const [locale, setLocale] = React.useState('fr');
    const [showCalendar, setShowCalendar] = React.useState(styles.hideCalendar);

    useEffect(() => {
        const language = GetLanguage();
        moment.locale(language);
        setLocale(language);
        loadTargetDate(new Date());
    }, []);

    useEffect(() => {
        if (props.saveDate != null) {
            loadTargetDate(new Date(formatDate(props.saveDate, 'date', '/') + ' 00:00'));
        }
    }, [props.saveDate]);

    const loadTargetDate = (date) => {
        const weekDay = getFirstLastDayWeek(date, startWeekDay);
        setStartDate(weekDay.firstDay);
        setEndDate(weekDay.lastDay);
        onChangeDate(weekDay.firstDay, weekDay.lastDay);
    };

    const onChangeDate = (start, end) => {
        props.onChangeDate(start, end);
    };

    const handleWeekBefore = () => {
        const beforeDay = RemoveDays(startDate, 1);
        getFirstLastDay(beforeDay);
    };

    const handleWeekAfter = () => {
        const nextDay = AddDays(endDate, 1);
        getFirstLastDay(nextDay);
    };

    const getFirstLastDay = (date) => {
        const weekDay = getFirstLastDayWeek(date, startWeekDay);
        setStartDate(weekDay.firstDay);
        setEndDate(weekDay.lastDay);
        setSelectedDate(new Date(formatDate(weekDay.firstDay, 'date')));
        onChangeDate(weekDay.firstDay, weekDay.lastDay);
    };

    const handleDatePicker = () => {
        setShowCalendar(styles.showCalendar);
    };

    const handleCancelCalendar = () => {
        setShowCalendar(styles.hideCalendar);
    };

    const handleDateChange = (event) => {
        getFirstLastDay(event.target.value);
        setShowCalendar(styles.hideCalendar);
    };

    const handleRefresh = () => {
        props.refresh();
    }

    return (
        <div id="divWeekSelect" className={styles.rootTimesheetSelect + ' ' + classes.rootSelectWeek}>
            <IconButton id="btnWeekBefore" size="small" aria-label="close" color="inherit" onClick={handleWeekBefore}>
                <ArrowBackIosIcon fontSize="small" />
            </IconButton>
            <IconButton size="small" aria-label="close" color="inherit" onClick={handleDatePicker}>
                {startDate} {i18next.t("timesheet:week-select.to")} {endDate}
            </IconButton>
            <IconButton id="btnWeekAfter" size="small" aria-label="close" color="inherit" onClick={handleWeekAfter}>
                <ArrowForwardIosIcon fontSize="small" />
            </IconButton>
            <IconButton id="btnWeekAfter" size="small" aria-label="close" color="inherit" className={classes.refreshButton} onClick={handleRefresh}>
                <FontAwesomeIcon icon={faArrowsRotate} />
            </IconButton>
            <div className={styles.datePicker + ' ' + showCalendar}>
                <LocalizationProvider language={locale}>
                    <IntlProvider locale={locale}>
                        <div>
                            <Calendar onChange={handleDateChange} />
                            <div>
                                <Button
                                    className={styles.cancelButton}
                                    variant="contained"
                                    color="primary"
                                    onClick={handleCancelCalendar}
                                >
                                    {i18next.t('buttons:cancel')}
                                </Button>
                            </div>
                        </div>
                    </IntlProvider>
                </LocalizationProvider>
            </div>
        </div>
    );
}

export default withNamespaces(['timesheet', 'buttons'], { wait: true })(WeekSelect);